<template>
  <div
    style="
      overflow: hidden;
      display: block;
      position: relative;
      margin-bottom: 0.12rem;
      background: #000;
      height: calc(100%);
    "
    class="body_"
  >
    <div class="SL_offerMaterialListView">
      <img
        @click="tg_video"
        :src="props.message.showImage || '../assets/LS1.png'"
      />
      <div class="SL_offerMaterialList_C">
        <span class="LSC_title">{{ props.message.title }}</span>
        <span class="LSC_time">{{ props.message.playTime }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { Axios } from "../assets/js/ls_com_axios.js";
const router = useRouter();
const from_muk_listing = ref("下架");
let iconChecked = ref(false);
const props = defineProps({
  muk_edit: {
    type: Boolean,
    // required: true
  },
  message: {},
});
const iconMouseover = function () {
  iconChecked.value = true;
};
const SLCB_bj = function () {
  iconChecked.value = false;
};
let muk_listing = ref(false);
const SLCB_sjzt = function () {
  iconChecked.value = false;
  muk_listing.value = true;
};
const emit = defineEmits([
  "ParticularsOverYse",
  "update:muk_edit",
  "deleteFunSucai",
]);
const SLCB_fx = function () {
  Axios(
    "POST",
    "/fodder/manage/share/" + props.message.id,
    null,
    false,
    function (res) {
      console.log(res.data);
      iconChecked.value = false;
      console.log(res.data.data.qrcodeUrl);
      emit("ParticularsOverYse", res.data.data.qrcodeUrl);
    }
  );
};

/* 详情页 */
const tg_video = function () {
  // router.push({
  // 	path: '/ShadowMaterialVideoParticulars',
  // 	query: {
  // 		id: props.message.id
  // 	}
  // })
};
</script>

<style scoped>
.SL_offerMaterialListView {
  position: relative;
  background: #000;
}
.SL_offerMaterialListView > img {
  width: 100%;
  display: block;
  overflow: hidden;
  /* border-radius: .12rem; */
  position: relative;
  margin: 0 auto;
  height: 1.7rem;
}

.SL_offerMaterialList_A {
  padding: 0.12rem 0.16rem;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* 
	.SL_offerMaterialListView:hover .SL_offerMaterialList_B {
		bottom: 0rem;
	}

	.SL_offerMaterialListView:hover .SL_offerMaterialList_C {
		bottom: -0.6rem;
	} */

.SL_offerMaterialList_A > span {
  color: #fff;
  font-size: 0.12rem;
}

.SL_offerMaterialList_A_title {
}

/* .SL_offerMaterialList_B {
		padding: 0.12rem 0.08rem;
		position: absolute;
		bottom: 0.0rem;
		left: 0;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		transition: bottom 0.5s
	} */

/* .SL_offerMaterialList_B:hover{
	bottom: -0.6rem;
} */

/* .SL_offerMaterialList_B, */
.SL_offerMaterialList_C {
  position: absolute;
  bottom: -0.6rem;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  pointer-events: none;
}

.SL_offerMaterialList_C {
  padding: 0.12rem 0.16rem;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  bottom: 0rem;
  /* transition: bottom 0.5s */
}

.SL_offerMaterialList_B_user,
.SL_offerMaterialList_B_imgList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.SL_offerMaterialList_B_user {
  padding: 0.04rem;
  border-radius: 1rem;
  background: rgba(0, 0, 0, 0.25);
  font-size: 0.12rem;
  color: #fff;
}

.SL_offerMaterialList_B_user > img {
  width: 0.24rem;
}

.SL_offerMaterialList_B_uimgList > img {
  width: 0.32rem;
}

.SL_offerMaterialList_C {
  font-size: 0.12rem;
  color: #ffffff;
}

.SLCB_list_top_definition_list {
  position: absolute;
  top: 0.15rem;
  right: 0.17rem;
}

.SLCB_list_top_definition_list > img {
  width: 0.24rem;
  background: #fff;
  border-radius: 0.02rem;
  padding: 0.02rem;
}

.SLCB_functionList {
  position: absolute;
  bottom: -1.25rem;
  left: -0.75rem;
  background: #fff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  padding: 0.04rem;
  width: 1rem;
  z-index: 0;
}

.SLCB_functionList > div {
  display: block;
  color: #333333;
  font-size: 0.12rem;
  text-align: center;
  padding: 0.06rem 0;

  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
}

.SLCB_functionList > view:hover {
  background: #f0f1f1;
}

.muk_listing_title {
  color: #000000;
  font-size: 0.14rem;
  margin-bottom: 0.16rem;
  margin-top: 0.21rem;
}

.dialog_b {
  margin-top: 0.2rem;
  display: flex;
  justify-content: center;
}

.dialog_b_qx {
  padding: 0.08rem 0.3rem;
  background: #fff;
  border: 0.01rem solid #333333;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-right: 0.2rem;
  color: #333333;
  font-size: 0.14rem;
}

.dialog_b_qd {
  color: #ffffff;
  font-size: 0.14rem;
  padding: 0.08rem 0.3rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.3rem;
}
.SL_offerMaterialListViewType {
  position: absolute;
  height: calc(100%);
  left: 0.16rem;
  top: 0.13rem;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0.13rem;
  padding: 0.04rem;
  color: #333333;
  font-size: 14px;
  z-index: 1;
}

/deep/.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #c01a26 !important;
  background: #c01a26 !important;
}
</style>
